import { type PageMenuItem } from '../types'

export const getActiveTopLevel = (data: PageMenuItem[]): PageMenuItem | undefined =>
  data.flatMap((item) =>
    // reason: still readable :)
    // eslint-disable-next-line no-nested-ternary
    item.isActive
      ? // easy, our top level item itself is active
        [item]
      : // when submenu item is active we give our top level as active back
        item.items?.some((subItem) => subItem.isActive)
        ? [item]
        : []
  )[0]
